import { fetchWithAuth } from "../utils/fetch/FetchWithAuth";
import { prepareBaseGetListParams } from "../utils/fetch/PrepareBaseGetListParams";

const baseUrl = '/portal/event-configs';
export const EventConfigService = {
 
    getList: (criteria) => {
        
        const params = prepareBaseGetListParams(criteria);
        const url = `${baseUrl}?${params.toString()}`;
        return fetchWithAuth(url, {
            method: 'GET'
        });
    },

    getEventTypeList: () => {
        return fetchWithAuth(`${baseUrl}/notification-types`, { method: 'GET' });
    },
    getEventPriorityList: () => {
        return fetchWithAuth(`${baseUrl}/priorities`, { method: 'GET' });
    },
    getStatuses:() =>{
        return fetchWithAuth(`${baseUrl}/statuses`, { method: 'GET' });
    },

    getManualTaskTypes: () => {
        return fetchWithAuth(`${baseUrl}/manual-task-types`, { method: 'GET' });
    },


    getEventConfig: (id) => {
        return fetchWithAuth(`${baseUrl}/${id}`, { method: 'GET' });
    },
    // createNotificationConfig: (config) => {

    //    // const notificationType = typeof config.type === 'object' ? config.type.id : config.type;
    //    // const priority = typeof config.criticality === 'object' ? config.criticality.id : config.criticality;
    //     //const notificationStatus = typeof config.notificationStatus === 'object' ? config.notificationStatus.id : config.notificationStatus;
    //  //   const generateServiceTask = typeof config.generateServiceTask === 'object' ? config.generateServiceTask.id : config.generateServiceTask;

    //     const request = {

    //         notificationType: config.notificationType,
    //         threshold: config.threshold,
    //         priority: config.priority,
    //         generateServiceTask: config.generateServiceTask || false,
    //         daysToArchive: config.daysToArchive || 30,
    //         notificationStatus: config.notificationStatus || 'ACTIVE'


    //     };
    
    //     return fetchWithAuth('/notifications/config', { method: 'POST', body: JSON.stringify(request) });
    // },
    updateEventConfig: (config) => {
        const request = {
            externalID: config.id,
            eventType: config.eventType,
            threshold: config.threshold,
            priority: config.priority?.id,
            generateServiceTask: config.generateServiceTask,
            manualTaskType: config.manualTaskType?.id,
            daysToArchive: config.daysToArchive,
            status: config.status?.id,
            displayOnErrorList: config.displayOnErrorList
        }
        return fetchWithAuth(`${baseUrl}/${config.id}`, { method: 'PUT', body: JSON.stringify(request) });
    },
    deactivate: (eventConfigId) => {
        return fetchWithAuth(`${baseUrl}/${eventConfigId}/deactivate`, {
            method: 'PUT'
        });
    },
    activate: (eventConfigId) => {
        return fetchWithAuth(`${baseUrl}/${eventConfigId}/activate`, {
            method: 'PUT'
        });
    }

}